export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/OrderTracking.24f1af5f.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};